<div class="SAS_Navbar">
  <!-- Header -->
  <app-outer-pages-header></app-outer-pages-header>

  <section class="about-jtc top-background no-printme">
    <div class="background-image-contact">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/']">الرئيسية</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              تواصل معنا
            </li>
          </ol>
        </nav>
        <h1 class="sub-title">نتطلع قدما لتواصلك معنا</h1>
      </div>
    </div>
  </section>

  <div class="intro2">
    <!-- <div class="container">
      <h4 class="sub-title heading-title mb-4 text-site-color">
        نتطلع قدما لتواصلك معنا
      </h4>
    </div> -->

    <div class="container">
      <div class="WhoAreWe section-padding">
        <div class="row g-24">
          <!-- <div class="col-lg-4 col-sm-12 box-edit">
            <div class="footer-links">
              <ul class="sm-links w-list list-box pr-3">
                <li class="row">
                  <div class="col-sm-2">
                    <i
                      class="fas fa-map-marker-alt fa-2x icon-edit text-red"
                    ></i>
                  </div>

                  <div class="col-sm-8">
                    <p class="font-size-22 mb-1 color-dark-gray">الموقع</p>
                    <a class="text-muted font-size-14">
                      6868, طريق أبو هريرة , حى المروج , 5473 , الرمز البريديى
                      62527 مدينة أبها.</a
                    >
                  </div>
                </li>

                <li class="row">
                  <div class="col-sm-2">
                    <i class="far fa-envelope fa-2x icon-edit text-yellow"></i>
                  </div>

                  <div class="col-sm-8">
                    <p class="font-size-22 mb-1 color-dark-gray">
                      البريد الإلكترونى
                    </p>
                    <a
                      href="mailto:info@mcsc-saudi.com"
                      class="text-muted font-size-14"
                      target="_blank"
                    >
                      info@mcsc-saudi.com
                    </a>
                  </div>
                </li>

                <li class="row">
                  <div class="col-sm-2">
                    <i class="fas fa-phone fa-2x icon-edit"></i>
                  </div>

                  <div class="col-sm-8">
                    <p class="font-size-22 mb-1 color-dark-gray">الهاتف</p>
                    <a
                      href="tel:9660172660007"
                      class="text-muted font-size-14"
                      target="_blank"
                      dir="ltr"
                      lang="en"
                    >
                      966 + (0) 17 266 0007
                    </a>
                  </div>
                </li>

                <li class="row">
                  <div class="col-sm-2">
                    <i class="fab fa-whatsapp fa-2x icon-edit text-green"></i>
                  </div>

                  <div class="col-sm-8">
                    <p class="font-size-22 mb-1 color-dark-gray">واتس أب</p>
                    <a
                      href="https://wa.me/966557266007"
                      class="text-muted font-size-14"
                      target="_blank"
                      dir="ltr"
                      lang="en"
                    >
                      055 7266 007
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div> -->

          <div class="col-lg-8 col-md-6 col-12">
            <!--The div element for the map -->
            <!-- <div id="map" style="width:100%;height:400px;"></div> -->
            <iframe
              src="https://maps.google.com/maps?q=%206137%20Northern%20Ring%20Rd,%202930%206137%20%D8%A7%D9%84%D8%B1%D9%8A%D8%A7%D8%B6%20SA%D8%8C%20%D8%A7%D9%84%D8%B1%D9%8A%D8%A7%D8%B6%2013313&t=&z=13&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="450"
              style="border-radius: 16px; border: none"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          <div class="col-lg-4 col-md-6 col-12">
            <div class="side-content side-contact card-light-border">
              <h3>تواصل معنا</h3>

              <div class="item">
                <h4>
                  <img
                    src="assets/images/icons/location-icon-green.svg"
                    alt="location icon"
                  />
                  الموقع
                </h4>
                <p>الطريق الدائري الشمالي، الرياض SA، الرياض 13313</p>
              </div>
              <div class="item">
                <h4>
                  <img
                    src="assets/images/icons/mail-icon-green.svg"
                    alt="mail icon"
                  />
                  البريد الإلكترونى
                </h4>
                <a href="mailto:info@cpt-it.com" target="_blank">
                  info@cpt-it.com
                </a>
              </div>
              <div class="item">
                <h4>
                  <img
                    src="assets/images/icons/phone-call-green.svg"
                    alt="phone icon"
                  />
                  الهاتف
                </h4>
                <a href="tel:966112455503" target="_blank" dir="ltr">
                  +966112455503
                </a>
              </div>
              <div class="item">
                <h4>
                  <img
                    src="assets/images/icons/whatsapp-icon-green.svg"
                    alt="whatsapp icon"
                  />
                  واتس أب
                </h4>
                <a href="https://wa.me/966112455503" target="_blank" dir="ltr">
                  966112455503
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-outer-pages-footer></app-outer-pages-footer>
</div>
